import { render, staticRenderFns } from "./enterpriseWorkbench.vue?vue&type=template&id=8452b386&scoped=true"
import script from "./enterpriseWorkbench.vue?vue&type=script&lang=js"
export * from "./enterpriseWorkbench.vue?vue&type=script&lang=js"
import style0 from "./enterpriseWorkbench.vue?vue&type=style&index=0&id=8452b386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8452b386",
  null
  
)

export default component.exports